<template>
<div>
  <jobseeker-signup title="Signup"
                    :subtitle="subtitle"
                    :progdetail="progdetail"
                    number="01"
                    description="Your name, etc."
                    detail="Just the basics to start with"
                    :formtype="formProfile"
                    v-on:continue="continuePressed"
                    :loading="loading"
                    :disabled="checkFormData"
                    :tasks="tasks">

    <image-edit :imageUrl="profilePictureUrl" title="Change avatar"
      v-on:change="uploadImage" :loading="uploading"
      :isRow="true" />
    <profile-form :showOptional="true" />
    </jobseeker-signup>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
import ProfileForm from '@/components/profile/profile-form'
import ImageEdit from '@/components/profile/image-edit'
import JobseekerSignup from '@/templates/jobseeker-signup'
import Actions from '@/api/actions'

export default {
  components: {
    ProfileForm,
    JobseekerSignup,
    ImageEdit
  },
  computed: {
    ...mapState('signupForm', {
      formProfile: 'profile'
    }),
    ...mapGetters('users', [
      'profilePictureUrl',
      'user'
    ]),
    ...mapGetters('profileForm', [
      'formData'
    ]),
    checkFormData () {
      const formData = this.formData
      if (formData.firstName.length !== 0 && formData.lastName.length) {
        return false
      }
    },
    subtitle () {
      let subtitle = ''
      switch (this.formProfile) {
        case 'Jobseeker':
          subtitle = this.$t('signup.subtitleJobseeker')
          break
        case 'Hirer':
          subtitle = this.$t('signup.subtitleJobseeker')
          break
        case 'Referrer':
          subtitle = this.$t('signup.subtitleReferrer')
          break
      }
      return subtitle
    },
    progdetail () {
      let detail = ''
      if (this.formProfile === 'jobseeker') {
        detail = 'Complete your profile to show who you are and see the jobs you really want'
      } else {
        detail = 'Complete your profile to show who you are and to get started referring people for jobs'
      }
      return detail
    },
    tasks () {
      let tasks = []
      if (this.formProfile === 'jobseeker') {
        tasks = [{
          name: 'Profile',
          completed: false
        }, {
          name: 'Job preferences',
          completed: false
        }]
      } else {
        tasks = [{
          name: 'Profile',
          completed: false
        }]
      }
      return tasks
    },
    ...mapState({
      formCompanyName: state => state.profileForm.companyName,
      formFirstName: state => state.profileForm.firstName,
      formLastName: state => state.profileForm.lastName
    })
  },
  async mounted () {
    await this.getUser()
    const user = this.user
    this.loadWithUser(user)
    if (this.formProfile === 'referrer') {
      this.tasks = [{
        name: 'Profile',
        completed: false
      }]
    }
  },
  methods: {
    ...mapMutations('profileForm', ['setFirstNameError', 'setLastNameError', 'setCompanyNameError']),
    ...mapActions('users', [
      'getUser',
      'uploadProfileImage',
      'updateUser'
    ]),
    ...mapActions('profileForm', [
      'loadWithUser'
    ]),
    selectAvatar () {
      const ele = this.$refs.profileImageUpload
      ele.click()
    },
    async uploadImage (file) {
      this.uploading = true
      await this.uploadProfileImage(file)
      window.setTimeout(() => {
        this.uploading = false
      }, 1000)
    },
    validations () {
      if (this.formFirstName.length === 0) {
        this.setFirstNameError('First Name is required')
        return false
      } else if (this.formLastName.length === 0) {
        this.setLastNameError('Last Name is required')
        return false
      } else if (this.formCompanyName.length === 0) {
        this.setCompanyNameError('Company Name is required')
        return false
      }
      return true
    },
    async continuePressed () {
      try {
        const validations = this.validations()
        if (!validations) {
          return false
        }
        this.loading = true
        const data = this.formData
        await this.updateUser(data)
        this.loading = false
        if (this.$ga) {
          this.$ga.event('Onboarding', 'Complete', this.formProfile, 1)
        }

        if (this.formProfile === 'referrer') {
          const { route } = await Actions.signup()
          this.$router.push(route)
        } else {
          this.$router.push('/signup/jobseeker/2')
        }
      } catch (e) {
        console.log('error', e)
      }
    }
  },
  data () {
    return {
      checked: true,
      uploading: false,
      loading: false
    }
  }
}
</script>

<style lang="scss" scoped>

.image-select {
  display: flex;
  margin-bottom: 24px;
}

.field {
  width: 100%;
}

.image-select a {
  margin-left: 12px;
}

.margin-title {
  margin-bottom: 40px;
}

.tracker {
  margin-top: -16px;
}

</style>



// WEBPACK FOOTER //
// src/pages/jobseeker-signup-1.vue